import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {mergeMap, delay, retryWhen, catchError} from 'rxjs/operators';
import { AuthService } from './auth.service';
import { getEnvironment } from '../environment/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class TokenInterceptorService implements HttpInterceptor {

  constructor(
    private inject:Injector,
    private toast: ToastrService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authservice = this.inject.get(AuthService);

    // * Habilitar cuando se tenga servicio del refresh token
    let cloneRequest = request.clone({});

    if(request.url.includes(getEnvironment().bridgeUrl)) {
      if(authservice.getBridgeToken()) {
        cloneRequest = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + authservice.getBridgeToken(),
          }
        });
      }

      return next.handle(cloneRequest).pipe(
        catchError(errorData => {
          console.log(errorData);
          if(errorData.status === 401) {
            authservice.logout('expired');
          }
          return throwError(errorData);
        })
      );
    }

    if(authservice.getToken()) {
      cloneRequest = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + authservice.getToken(),
        }
      });
    }

    return next.handle(cloneRequest).pipe(
      catchError(errorData => {
        console.log(errorData);
        if(errorData.status === 401) {
          authservice.logout('expired');
        }
        return throwError(errorData);
      })
    );
  }


  addTokenHeader(request: HttpRequest<any>, token: any) {
    return request.clone({ headers: request.headers.set('Authorization', 'Bearer '+ token) });
  }
}


export const maxRetries = 2;
export const delayMs = 2000;

export class ErroInterceptorService implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retryWhen((error) => {
        return error.pipe(
          mergeMap((error, index) => {
            if (error.status == 401) {
              console.log(error);
            } else {
              if (index < maxRetries && error.status == 500) {
                return of(error).pipe(delay(delayMs));
              }
            }

            throw error;
          })
        )
      })
    )
  }
}
